module.exports = __webpack_public_path__ + "img/112-benjamin_franklin_quotes.7e3ca5ad.jpeg";